export const Dots = ({ isLoading }) => {
    const FILL_COLOR = "white";
    const GAP = 33;
    const RADIUS = 8.8;
    const Circle = ({ row, col, factor }) => (
        <circle
            r={RADIUS * factor}
            cx={(row * GAP) + 15.5}
            cy={(col * GAP) + 5.5}
            fill={FILL_COLOR}
        >
            <animate
                attributeName="opacity"
                values="0.5;1;0.5"
                dur={row * 1.3 + "s"}
                repeatCount="indefinite"
            />
        </circle>
    );
    return (
        <>
            {isLoading && (
                <div className="w-full h-full flex flex-col justify-center items-center bg-black / 75">
                    <svg xmlns="http://www.w3.org/2000/svg" width="225" height="25" className="absolute bottom-[20%]">
                        <Circle col={0} row={2} factor={0.3} />
                        <Circle col={0} row={3} factor={0.4} />
                        <Circle col={0} row={4} factor={0.6} />
                    </svg>
                </div>
            )}
        </>
    )
}